import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { MarketCreators } from "redux/modules/market";

import MarketItem from "../home/MarketItem";
import { MOCK_USER_ID } from "../home/MarketHome";

import styled from "styled-components";

function InfiniteScroll({
  page,
  totalLength,
  searchedMarkets,
  keyWord,
  pageFunc,
  setSearchedMarketsFunc,
}) {
  const dispatch = useDispatch();
  const targetRef = useRef();

  const totalPage = Math.ceil(totalLength / 5); //총페이지
  const callback = ([entries]) => {
    if (entries.isIntersecting) {
      pageFunc();
    }
  };

  useEffect(() => {
    const payload = {
      user_id: MOCK_USER_ID,
      searchNm: keyWord.trim().replace(/ +(?= )/g, ""),
      page: page + 1, // 첫 렌더링시 0페이지가 또 들어가져서 +1 처리
    };
    if (totalPage > page + 1) {
      dispatch(MarketCreators.marketSearch(payload))
        .unwrap()
        .then((res) => {
          setSearchedMarketsFunc(res.data);
        });
    } else {
      return;
    }
  }, [dispatch, keyWord, page]);

  useEffect(() => {
    if (!targetRef.current) return;
    const observer = new IntersectionObserver(callback, {
      threshold: 1,
    });
    observer.observe(targetRef.current);
  }, [targetRef]);

  return (
    <div className="searchedList">
      {searchedMarkets.map((item) => (
        <div key={item.whole_id} className="searchedItem">
          <MarketItem item={item} />
        </div>
      ))}
      {totalPage > page + 1 && (
        <Loading className="target" ref={targetRef}>
          Loading...
        </Loading>
      )}
    </div>
  );
}

export default InfiniteScroll;

const Loading = styled.div`
  text-align: center;
`;
